// @ts-check
// Estado compartilhado das conversas: contador de não lidas da navegação e polling enquanto
// o tempo real não existe (contrato de conversas, seção 6).
import { signal } from '@preact/signals';
import { useEffect, useRef } from 'preact/hooks';
import { listThreads } from '../../data/conversations.js';

export const CONVERSATION_POLLING_INTERVAL_MILLISECONDS = 10_000;
const UNREAD_POLLING_INTERVAL_MILLISECONDS = 30_000;
const UNREAD_PAGE_LIMIT = 100;

/** Conversas com mensagens não lidas, para o selo do item "Conversas" na navegação. */
export const unreadConversationCountState = signal(0);

export async function refreshUnreadConversationCount() {
  try {
    const { threads } = await listThreads({ unreadOnly: true, limit: UNREAD_PAGE_LIMIT });
    unreadConversationCountState.value = threads.filter((thread) => thread.unreadCount > 0).length;
  } catch {
    // Sem a rota (backend ainda sem conversas) o selo só não aparece.
  }
}

/**
 * Chama a função a cada intervalo com a aba visível, e de imediato ao voltar para a aba.
 * @param {() => void} callback
 * @param {number} intervalMilliseconds
 * @param {boolean} [enabled]
 */
export function usePolling(callback, intervalMilliseconds, enabled = true) {
  const callbackRef = useRef(callback);
  callbackRef.current = callback;
  useEffect(() => {
    if (!enabled) return undefined;
    const tick = () => {
      if (document.visibilityState === 'visible') callbackRef.current();
    };
    const interval = setInterval(tick, intervalMilliseconds);
    document.addEventListener('visibilitychange', tick);
    return () => {
      clearInterval(interval);
      document.removeEventListener('visibilitychange', tick);
    };
  }, [intervalMilliseconds, enabled]);
}

/** Mantém o selo de não lidas atualizado em qualquer página. */
export function useUnreadConversationPolling(enabled = true) {
  useEffect(() => {
    if (enabled) refreshUnreadConversationCount();
  }, [enabled]);
  // papel sem conversas (Coordenação, Visitas) não consulta: a API responderia 403
  usePolling(refreshUnreadConversationCount, UNREAD_POLLING_INTERVAL_MILLISECONDS, enabled);
}
